import React from "react";
import UsageGuideCard from "../usage-guide-card/UsageGuideCard";
import UsageGuideStepProps from "./usage-guide-step-props.interface";
import { ReactComponent as YellowArrowRightIcon } from "../../../../../assets/icons/yellow-arrow-right-icon.svg";

const TintStatusToggle = ({handleNextStep, handleClose}: UsageGuideStepProps) => {
    return             <div className="step__tint-status-toggle">
        <UsageGuideCard handleClose={handleClose}>
          <div className="d-flex">
            <div className="mb-5">
              <h1>Tint Status</h1>
              <p>Explore here the status of tints in the glass of the building.</p>
            </div>
            <div className="align-self-end">
              <button
                type="button"
                onClick={handleNextStep}
                className="clickable"
              >
                Next
                <YellowArrowRightIcon/>
              </button>
            </div>
          </div>
        </UsageGuideCard>
      </div>
}

export default TintStatusToggle;
